<template>
  <header class="header">
    <div class="container">
      <div class="logo">
        <router-link to="/">
          <img src="@/assets/logo.png" alt="长春合利水土保持科技有限公司" />
          <span class="company-name">长春合利水土保持科技有限公司</span>
        </router-link>
      </div>
      <nav class="nav">
        <ul>
          <li><router-link to="/" :class="{ active: $route.path === '/' }">首页</router-link></li>
          <li><router-link to="/about" :class="{ active: $route.path.startsWith('/about') }">关于我们</router-link></li>
          <li><router-link to="/products" :class="{ active: $route.path === '/products' }">产品中心</router-link></li>
          <li><router-link to="/services" :class="{ active: $route.path === '/services' }">技术服务</router-link></li>
          <li><router-link to="/news" :class="{ active: $route.path.startsWith('/news') }">新闻动态</router-link></li>
          <li><router-link to="/hr" :class="{ active: $route.path === '/hr' }">招聘信息</router-link></li>
          <li><router-link to="/contact" :class="{ active: $route.path === '/contact' }">联系我们</router-link></li>
        </ul>
      </nav>
      <div class="mobile-menu-btn" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  methods: {
    toggleMenu() {
      document.querySelector('.nav').classList.toggle('active')
    }
  }
}
</script>

<style scoped>
.header {
  background: linear-gradient(135deg, #6aa9f3 0%, #0077ff 100%);
  box-shadow: 0 2px 12px rgba(0, 81, 173, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  border-bottom: 2px solid rgba(0, 81, 173, 0.1);
  transition: all 0.3s;
}

.header:hover {
  box-shadow: 0 4px 16px rgba(0, 81, 173, 0.15);
  border-bottom-color: #1890ff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
}

.logo a {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #0051ad;
}

.logo img {
  height: 90px;
  margin-right: 12px;
}

.company-name {
  font-size: 22px;
  font-weight: bold;
  color: white;
}

.nav ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav li {
  margin-left: 30px;
}

.nav a {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  padding: 8px 0;
  transition: all 0.3s;
  position: relative;
  font-weight: 500;
}

.nav a:hover,
.nav a.active {
  color: white;
  font-weight: 600;
}

.nav a.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: white;
  border-radius: 2px;
}

.mobile-menu-btn {
  display: none;
  flex-direction: column;
  cursor: pointer;
}

.mobile-menu-btn span {
  width: 25px;
  height: 3px;
  background: white;
  margin: 3px 0;
  transition: 0.3s;
  border-radius: 2px;
}

@media (max-width: 768px) {
  .company-name {
    font-size: 14px;
  }

  .mobile-menu-btn {
    display: flex;
  }

  .nav {
    position: fixed;
    top: 80px;
    left: -100%;
    width: 100%;
    height: calc(100vh - 80px);
    background: linear-gradient(to bottom, #ffffff 0%, #f8f9fa 100%);
    transition: left 0.3s;
    box-shadow: 0 4px 16px rgba(0, 81, 173, 0.12);
  }

  .nav.active {
    left: 0;
  }

  .nav ul {
    flex-direction: column;
    padding: 20px;
  }

  .nav li {
    margin: 10px 0;
  }
}
</style>
